import { render, staticRenderFns } from "./OpenserveService.vue?vue&type=template&id=77355648&"
import script from "./OpenserveService.vue?vue&type=script&lang=js&"
export * from "./OpenserveService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports